import { Label } from ".";
import { classNames, formatCurrency } from "../../utils/helpers";

export default function NumberInput({
  label,
  subLabel,
  name,
  placeholder = "",
  required = false,
  value,
  min,
  max,
  onChange,
  id,
  isCurrency,
  isPennies
}) {
  return (
    <div id={id}>
      {/* Label/required asterisk */}
      {label && <Label label={label} required={required} />}
      <div className={classNames("flex relative", label ? "mt-1" : "")}>
        {/* Input */}
        <input
          type="number"
          name={name}
          className="p-2 rounded-s-md focus:outline-none block w-full sm:text-sm border-s border-y border-gray-200 placeholder-gray-300"
          placeholder={placeholder}
          required={required}
          value={value}
          min={min}
          max={max}
          onChange={onChange}
          readOnly={!onChange}
          autoComplete="off"
        />
        {!!isCurrency && !!value && (<div className="flex text-gray-500 p-2 bg-white rounded-e-md border-e border-y border-gray-200">{formatCurrency(value, isPennies)}</div>)}
      </div>
      {/* Sublabel */}
      {subLabel && (
        <div className="mt-1 text-gray-400 text-xs text-right">{subLabel}</div>
      )}
    </div>
  );
}
